module.exports = "<template> ${ value.fromDate | date:\"L\" } - ${ value.toDate | date:\"L\" } </template> ";